import { serializeError } from 'owa-offline-errors';

// Serialize errors thrown in worker actions to ensure full info makes it back to the main thread
export function serializeRejection<T extends (...args: any[]) => Promise<any>>(fn: T): T {
    return async function (...args: Parameters<T>): Promise<ReturnType<T>> {
        try {
            return await fn(...args);
        } catch (error) {
            throw serializeError(error);
        }
    } as T;
}
